import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DriverSelect from "./DriverSelect";

const mapStateToProps = (state) => ({
  companies: state.companies,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverSelect);
